import React from 'react';
import { useAuth } from '../context/AuthContext';

const GracePeriodBanner = () => {
  const { graceActive, graceEndsAt } = useAuth();

  if (!graceActive) return null;

  const endDate = graceEndsAt
    ? new Date(graceEndsAt).toLocaleDateString(undefined, { year: 'numeric', month: 'long', day: 'numeric' })
    : '';

  return (
    <div style={styles.banner}>
      <span style={styles.text}>
        You have full access until <strong>{endDate}</strong>. After that, Opportunities and Trades require a paid plan.
      </span>
    </div>
  );
};

const styles = {
  banner: {
    background: '#1c2d3a',
    borderBottom: '1px solid #1f6feb',
    padding: '8px 16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    fontSize: '12px',
    color: '#79c0ff',
  },
  text: { flex: 1 },
};

export default GracePeriodBanner;
